/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  recordedVideo: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetRecordTaskVideoAction.GET_RECORD_TASK_VIDEO:
      return {
        ...state
      };
    case actions.GetRecordTaskVideoAction.RECORD_TASK_VIDEO_RESPONSE:
      return {
        ...state,
        recordedVideo: action.data.videoPath
        // userid: action.payload.user_ID,
        // projectid: action.payload.project_ID,
      };
    case actions.GetRecordTaskVideoAction.RESET_TASK_VIDEO:
      return {
        ...state,
        recordedVideo: null
      };

    default:
      return state;
  }
};

export default reducer;
